import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'
import fetchHeavyStompunkter from '../dataSource/fetchHeavyStompunkter'

export function loadHeavyStompunkterIfNeeded(ids) {
	return function(dispatch, getState) {
		const cachedStompunkter = getState().heavyStompunkter
		const missingIds = ids.filter((id) => !(id in cachedStompunkter))
		if (missingIds.length !== 0) {
			dispatch(loadHeavyStompunkter(missingIds))
		}
	}
}

export function loadHeavyStompunkter(ids) {
   return async function(dispatch, getState) {
      let stompunkter
      const srid = getState().srid
      dispatch(loadHeavyStompunkterRequest(ids, srid))
      try {
         stompunkter = await fetchHeavyStompunkter(ids, srid)
      }
      catch (error) {
         dispatch(loadHeavyStompunkterError(error, ids, srid))
         return;
      }
      dispatch(loadHeavyStompunkterSuccess(stompunkter, ids, srid))
   }
}

export const loadHeavyStompunkterRequest = createActionCreator(actions.LOAD_HEAVY_STOMPUNKTER_REQUEST, 'ids', 'srid')

export const loadHeavyStompunkterError = createActionCreator(actions.LOAD_HEAVY_STOMPUNKTER_ERROR, 'error', 'ids', 'srid')

export const loadHeavyStompunkterSuccess = createActionCreator(actions.LOAD_HEAVY_STOMPUNKTER_SUCCESS, 'stompunkter', 'ids', 'srid')



// WEBPACK FOOTER //
// ./src/actionCreators/loadHeavyStompunkter.js